const MENU_ITEM_STATUSES = {
  CREATED: 'CREATED',
  UPDATED: 'UPDATED',
  UPDATED_SIGNIFICANTLY: 'UPDATED_SIGNIFICANTLY',
  DELETED: 'DELETED',
  RESTORED: 'RESTORED',
}

export default MENU_ITEM_STATUSES
